import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import '../styles/page-layout.css';

const NotFoundPage: React.FC = () => {
  return (
    <Layout
      title="Seite nicht gefunden | StimmDigital"
      description="Die angeforderte Seite wurde nicht gefunden. Kehre zur Startseite zurück oder entdecke unsere Services."
      keywords="404, Seite nicht gefunden, Error"
    >
      <section className="wrapper">
        <div className="page-container" style={{ textAlign: 'center', padding: '4rem 2rem' }}>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <h1 style={{ 
              fontSize: '6rem', 
              fontWeight: '800', 
              background: 'linear-gradient(135deg, var(--primary-color), var(--secondary-color))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              marginBottom: '1rem'
            }}>
              404
            </h1>
            
            <h2 style={{ 
              fontSize: '2rem', 
              marginBottom: '1rem',
              color: 'var(--text-color)'
            }}>
              Seite nicht gefunden
            </h2>
            
            <p style={{ 
              fontSize: '1.1rem', 
              color: 'var(--text-muted)',
              marginBottom: '3rem',
              lineHeight: '1.6'
            }}>
              Die Seite, die du suchst, konnte nicht gefunden werden. 
              Möglicherweise wurde sie verschoben oder existiert nicht mehr.
            </p>

            <div style={{ 
              display: 'flex', 
              gap: '1rem', 
              justifyContent: 'center',
              flexWrap: 'wrap',
              marginBottom: '3rem'
            }}>
              <Link 
                to="/" 
                style={{ 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '1rem 2rem',
                  background: 'linear-gradient(135deg, #77F76C, #0A8370)',
                  color: 'white',
                  borderRadius: '0.75rem',
                  fontWeight: '600',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease',
                  border: 'none',
                  boxShadow: '0 4px 12px rgba(119, 247, 108, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(119, 247, 108, 0.4)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #0A8370, #0A8370)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(119, 247, 108, 0.3)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #77F76C, #0A8370)';
                }}
              >
                <i className="fas fa-home" style={{ marginRight: '0.5rem' }}></i>
                Zur Startseite
              </Link>
              
              <Link 
                to="/beratungstermin" 
                style={{ 
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '1rem 2rem',
                  backgroundColor: 'transparent',
                  color: '#77F76C',
                  borderRadius: '0.75rem',
                  fontWeight: '600',
                  fontSize: '1rem',
                  transition: 'all 0.3s ease',
                  border: '2px solid #77F76C',
                  boxShadow: '0 4px 12px rgba(119, 247, 108, 0.15)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(119, 247, 108, 0.25)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #77F76C, #0A8370)';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(119, 247, 108, 0.15)';
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.color = '#77F76C';
                }}
              >
                <i className="fas fa-calendar" style={{ marginRight: '0.5rem' }}></i>
                Kostenloses Beratungsgespräch
              </Link>
            </div>

            <div style={{ 
              marginTop: '2rem',
              textAlign: 'center'
            }}>

            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFoundPage;
